import { Box, Button, Typography } from '@mui/material';
import useResponsive from '@/components/hooks/useResponsive';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { SxClassProps } from '@/types';

interface HeroProps {
  /** Callback function when "Explore Plans" is clicked */
  onExplorePlansClick: () => void;
}

const classes: SxClassProps = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    pt: { md: 2 },
    pb: { xs: 2, md: 4 },
  },
  contentBox: {
    maxWidth: { xs: '100%', sm: '570px', md: '660px' },
    px: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    maxWidth: { xs: '400px', sm: '500px', md: '585px' },
    mt: { xs: 4, md: 8 },
    mb: { xs: 2 },
  },
  subtitle: {
    textAlign: 'center',
  },
  button: {
    width: { xs: '100%', sm: 184 },
    my: 4,
  },
};

const Hero = ({ onExplorePlansClick }: HeroProps) => {
  const { isDesktop } = useResponsive();

  const onButtonClick = () => {
    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED,
      data: {
        cta_text: CtaText.EXPLORE_PLANS,
        cta_location: CtaLocation.HERO,
        screen_name: ScreenName.PLANS_AND_PRICING,
        vertical: 'Unknown',
        enrollment_initiated: false,
      },
    });
    onExplorePlansClick();
  };

  return (
    <Box data-testid="hero-section" sx={classes.container}>
      <Box sx={classes.contentBox}>
        <Typography variant={isDesktop ? 'display1' : 'display2'} sx={classes.title}>
          Care for your family, all in one place
        </Typography>
        <Typography variant={isDesktop ? 'body1' : 'body2'} sx={classes.subtitle}>
          Keep life moving with access to background-checked caregivers that fit your needs—rated
          and reviewed by people like you.
        </Typography>
        <Button
          color="primary"
          variant="contained"
          size="large"
          sx={classes.button}
          onClick={onButtonClick}>
          {CtaText.EXPLORE_PLANS}
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;
